// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"546ebd20","736":"203a0cc5"}[chunkId] + ".chunk.js";
};